module.exports = __webpack_public_path__ + "c8cbd5a5bb072b9ea8fbc474a0c559c7.fbx";